import * as yup from 'yup';

export const newProductoSchema = yup.object({
  codigo: yup.string().required('Campo Requerido'),
  // codigo_secundario: yup.string().required('Campo Requerido'),
  numero_referencia: yup.string().required('Campo Requerido'),
  descripcion: yup.string().required('Campo Requerido'),
  recurrencia_compra: yup.string().required('Campo Requerido'),
  stock_actual: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  //acepta_negativo: yup.boolean().required('Campo Requerido'),
  costo_compra: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  costo_actual: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  costo_promedio: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  marca_producto: yup.string().required('Campo Requerido'),
  modelo_producto: yup.string().required('Campo Requerido'),

  /* es_activo: yup.boolean().required('Campo Requerido'),
  es_para_venta: yup.boolean().required('Campo Requerido'),
  es_fibra: yup.boolean().required('Campo Requerido'),
  es_utp: yup.boolean().required('Campo Requerido'),
  es_ont: yup.boolean().required('Campo Requerido'), */

  stock_minimo: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  stock_maximo: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  stock_seguridad: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  // presentacion: yup.string().required('Campo Requerido'),
  categoria_producto: yup.string().required('Campo Requerido'),
  subcategoria_producto: yup.string().required('Campo Requerido'),
  // iva: yup.string().required('Campo Requerido'),
  unidad_medida: yup.string().required('Campo Requerido'),
  // proveedor: yup.string().required('Campo Requerido'),

  //aux
  precio_1: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  precio_2: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  precio_3: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
  //precio_4: yup.number().required('Campo Requerido').typeError('Campo Requerido'),
});